export const COLORS = ['#ffffff', '#d3d3d3', '#243143', '#d10000', '#01b167', '#0008d1'];
